import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=6ebf2440&scoped=true&"
import script from "./ContactForm.vue?vue&type=script&lang=js&"
export * from "./ContactForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=6ebf2440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebf2440",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/contact_form.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fcommons%2FContactForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports